/** Shared API cache TTL: 3 minutes (client React Query + Next.js Data Cache). */
export const API_CACHE_TTL_MS = 3 * 60 * 1000

export const API_CACHE_REVALIDATE_SECONDS = API_CACHE_TTL_MS / 1000
